app.config(function ($stateProvider) {
    // Now set up the states
    $stateProvider
        .state('redirect', {
            url: '/redirect?notification&link&jobResource&jobRedirectResource&quoteRedirectResource&file&open-close&expiry&token&thumbUp&reporterName&reporterEmail&reporterPhone&unsubscribe&p2p&exportId',
            templateUrl: 'shared-templates/loading.html',
            controller: 'RedirectController'
        });
});
